import { Autocomplete, TextField } from '@mui/material'
import React from 'react'
import { Receivable } from '../../../graphQL/ReceivablesForm'
import { useBayLocations } from '../../../providers/BayLocationsProvider'
import { setTableFields, TableFieldProps, useReceivablesFormDispatch, useReceivablesFormState } from '../../../providers/ReceivablesFormProvider'

interface Props {
  receivableId: number
  disabled: boolean
}

export interface LocationsInterface {
  Location: string
  BayID: number | ''
}

export default function Locations({ receivableId, disabled }: Props) {
  const dispatch = useReceivablesFormDispatch()
  const { receivablesFormCopy } = useReceivablesFormState()
  const { bayLocations } = useBayLocations() // Use bayLocations from the provider
  const [receivableItem, setReceivableItem] = React.useState<Receivable | undefined>(undefined)
  const [selectedBay, setSelectedBay] = React.useState<number | string>('')

  React.useEffect(() => {
    if (receivablesFormCopy?.items) {
      const targetItem = receivablesFormCopy.items.find((rec) => rec.ReceivableID === receivableId)
      setReceivableItem(targetItem)
    }
  }, [receivablesFormCopy?.items, receivableId])

  React.useEffect(() => {
    if (receivableItem) {
      setSelectedBay(receivableItem?.Storage[0]?.BayID ?? '')
    }
  }, [receivableItem])

  return React.useMemo(
    () => (
      <>
        {disabled
          ? (
            <>
              {bayLocations.find((location: LocationsInterface) => location.BayID === selectedBay)?.Location ||
                'Unknown Bay/Location'}
            </>
            )
          : (
            <div>
              <Autocomplete
                options={bayLocations.length > 0 ? bayLocations : [{ Location: 'Loading...', BayID: '' }]}
                getOptionLabel={(option) => option.Location}
                isOptionEqualToValue={(option, value) => option.BayID === value.BayID}
                value={bayLocations.find((location) => location.BayID === selectedBay) || null}
                onChange={(event, newValue) => {
                  const newBayID = newValue ? newValue.BayID : ''
                  setSelectedBay(newBayID)

                  const newField: TableFieldProps = {
                    name: `${receivableId}-BayID`,
                    value: newBayID,
                    checked: false
                  }

                  setTableFields(dispatch, newField)
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    placeholder="Select Bay/Location"
                  />
                )}
              />
            </div>
            )}
      </>
    ),
    [dispatch, receivableId, bayLocations, selectedBay, disabled]
  )
}
